import React from 'react'


function Redirect() {
    return (
        <div className='h-container'>
            <h1>Hello 😃</h1>
            <a href='/new' className='newLink'>Create New</a>
            <br />
            <br />
            Made with ❤️ by <a href="http://snowbit.vercel.app" target="_blank" rel="noopener noreferrer">SnowBit</a>
        </div>
    )
}

export default Redirect
